<template>
<el-row>
  <el-col :xs="{offset:0,span:24}" :sm="{offset:2,span:20}" class="top-nav-content">
    <div @click="direct('#/home')" class="top-nav-logo">
      <img src="../assets/ohm-logo.jpg">
    </div>
    <div @click="direct('#/home')" class="top-nav-button hidden-xs-only">Submit</div>
    <div @click="direct('#/queue')" class="top-nav-button hidden-xs-only">Queue</div>
    <div @click="direct('#/help')" class="top-nav-button hidden-xs-only">Help</div>
    <div @click="showContact" class="top-nav-button hidden-xs-only">Contact</div>

    <contact v-model="contactVisible"></contact>

  </el-col>
</el-row>
</template>

<script>

import Contact from './Contact.vue'

export default {
  name: 'TopNav',

  data () {
    return {
      contactVisible: false
    }
  },

  components: {
    Contact
  },

  methods: {
    direct (url) {
      this.$store.dispatch('direct', url)
    },

    showContact () {
      if (!this.$store.state.user) {
        alert('Please login!')
      } else {
        this.contactVisible = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.top-nav-content {
  /*
  width: $content-width;
  margin: 20px auto;
  */
  color: $font-grey;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 120px;
}

.top-nav-content >div {
  margin-right: 30px;
}

.top-nav-logo {
  font-size: 45px;
  font-weight: 500;
  cursor: pointer;
  height: 70px;
}

.top-nav-logo img {
  height: 100%;
  width: auto;
}

.top-nav-logo img:hover {
  opacity: 0.5;
}

.top-nav-button {
  font-weight: 700;
  cursor: pointer;
}

.top-nav-button:hover {
  opacity: 0.5;
}

</style>

